module.exports = __webpack_public_path__ + "static/fonts/CircularStd-Black.e5128bf4.svg";